export default "__VITE_ASSET__aof2lOg$__"